import ContentLoader from 'react-content-loader';

const MessageListSkeleton = () => (
  <ContentLoader
    speed={1}
    width="100%"
    height={360}
    opacity={0.7}
    backgroundColor="#e0e0e0"
    foregroundColor="#c8c8c8"
  >
    {/* Left Message */}
    <rect x="2%" y="20" rx="12" ry="12" width="40%" height="40" />

    {/* Right Message */}
    <rect
      x="calc(100% - 2% - 40%)"
      y="80"
      rx="12"
      ry="12"
      width="40%"
      height="40"
    />

    {/* Left Message */}
    <rect x="2%" y="140" rx="12" ry="12" width="40%" height="40" />

    {/* Right Message */}
    <rect
      x="calc(100% - 2% - 40%)"
      y="200"
      rx="12"
      ry="12"
      width="40%"
      height="40"
    />

    {/* Left Message */}
    <rect x="2%" y="260" rx="12" ry="12" width="40%" height="40" />

    {/* Right Message */}
    <rect
      x="calc(100% - 2% - 40%)"
      y="320"
      rx="12"
      ry="12"
      width="40%"
      height="40"
    />
  </ContentLoader>
);

export default MessageListSkeleton;
